import axios from "axios";
import qs from "qs";
import { push, replace } from 'svelte-spa-router';
import sha1 from 'crypto-js/sha1';
import jwt_decode from 'jwt-decode';

import { emeters, integrated_list, loaded, user } from './stores';
import {FLAG, EXTENDED, SYNC_TYPE} from "./constants";

export const http = async () => {

	axios.defaults.baseURL = 'https://api.shelly.cloud/';

	let storedUser;
	const unsubscribe = user.subscribe(value => {
		storedUser = value;
	});

	if (Object.keys(storedUser).length > 0) {
		handleBaseUrl(storedUser.user_api_url);

		if (expireTime(storedUser.token) > 0) {

			handleToken(storedUser.token);
			handleInitialLoad(storedUser)

		} else {
			refreshToken()
				.then(() => {
					handleToken(storedUser.token);
					handleInitialLoad(storedUser)
				})
				.catch(err => console.log('Error on initial load with existing user ', err));
		}
	} else {
		axios.defaults.baseURL = 'https://api.shelly.cloud/';
		
	};

};

export const handleBaseUrl = (baseUrl) => {
	axios.defaults.baseURL = baseUrl;
};

export const postReq = async (url, data) => {
	try {
		let res = await axios.post(url, qs.stringify(data))
		return res;
	} catch (error) {
		return error.response
	}
};


const expireTime = (jwt) => {
	let decoded = jwt_decode(jwt);
	let timer = (decoded.exp * 1000 - Date.now()) - 1500;
	return timer;
}

const startWatchExpire = (jwt) => {
	/**
	 * Decode jwt and get expiration time.
	 * If token expiration time < 1500 ms update tokens immediately
	 * else use the differenca between time as a timer to update tokens
	 */
	let timer = expireTime(jwt);
	if (timer < 0) timer = 0;

	setTimeout(async () => {
		try {
			await refreshToken();
		} catch (error) {
			await push('/login');
		}
	}, timer);

};
// TOKEN ----------------------------------------------------------------------------------
export const handleToken = (jwt) => {
	axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
	startWatchExpire(jwt)
};

export const standart_login = async (email, pass) => {
	try {
		let res = await axios.post("https://api.shelly.cloud/auth/login",
			qs.stringify({
				email: email,
				password: pass
			}));

		let data = { ...res.data.data, email: email, password: pass };
		return data;

	} catch (error) {
	}
};

// LOGIN ---------------------------------------------------------------------------------
export const handle_login = async (email, pass) => {
	try {
		const hashPass = sha1(pass).toString();

		let res = await standart_login(email, hashPass);
		
		user.set(res);
		//set up user language after login step
		handleBaseUrl(res.user_api_url)
		handleToken(res.token)

		await handleInitialLoad(res)

		push('/');

	} catch (error) {
		user.set(false);
		await push('/login');
	}
};


export const refreshToken = async (email, pass) => {
	try {
		let userObj;
		user.subscribe(v => userObj = v);
		let data = await standart_login(userObj.email, userObj.password)

		if (data) {
			user.set(data);
			handleBaseUrl(data.user_api_url);
			handleToken(data.token);
			return true;
		}
		return false;
	} catch (error) {
		return false;
	}
};

export const handle_logout = async () => {
	//make http call
	let logout = await axios.post("https://api.shelly.cloud/auth/logout", {});

	user.set({});
	integrated_list.setIntegrated([]);
	emeters.setEmeters([])
	// clear storage after reseting all stores 
	localStorage.clear();
	await push('/login');
};

export const getIntegratedDevices = async () => {
	try {
		let devices = await postReq("/integrated_api/integrated_devices", {flag: FLAG});
		if(devices.data.isok && devices?.data?.data?.devices){
			integrated_list.setIntegrated(devices.data.data.devices);
		}
		return {devices};
	} catch (error) {
		return error;
	}
}

export const getAllLists = async () => {
	try {
		let lists = await postReq("/interface/device/list", {});
		if (lists.data && lists.data.data) {
            lists = Object.values(lists?.data?.data?.devices).filter(d =>d.type === 'SHEM-3' && d.category === 'emeter' && !d.shared)
            emeters.setEmeters(lists);
		} else {
            emeters.setEmeters([])
        }
        
		return { lists };

	} catch (error) {
		return error;
	}
};

export const handleInitialLoad = (data) => {
	return Promise.all([getAllLists(), getIntegratedDevices()])
		.then(res => {
		
			if(res[0]?.lists && res[1]?.devices?.status === 200){
				loaded.set(true)
			}
		})
		.catch(err => console.log('Error on initial load ', err))
};


// call PHP for subscribe and unsubscribe user data

export const subscribeIntegration = async(devices = []) => {
	try {
		let res = await postReq("/integrated_api/subscribe_iotn", {
			flags: FLAG,
			devices: devices.join(","),
			syncType: SYNC_TYPE,
			extended: EXTENDED
		});

		return res;
	} catch (error) {
		
	}
}

export const updateIntegration = async (devices) => {
	try {
		let res = await postReq("/integrated_api/update_iotn", {
			flags: FLAG,
			devices: devices.join(","),
			syncType: SYNC_TYPE
		});
		return res;
	} catch (error) {
		return error;
	}
}

export const unsubscribeIntegration = async () => {
	try {
		let unsubscribeIt = await postReq("/integrated_api/unsubscribe_iotn", {flags: FLAG});
		return unsubscribeIt;
	} catch (error) {
		return error;
	}
}